import React, {useContext, useEffect, useState} from "react";
import axios from "axios";
import {
    Elink, CreateNewRoomUrl, FetchRoomCategoriesUrl
} from "../CommonComponents/Routes";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import {Animation} from "./Animation";
import MobileLinkLoader from "./MobileLinkLoader"
import {AnimationPrevious} from "./AnimationPrevious";
import {GetTextColor} from "./GetTextColor";

const AddNewRoom = () => { // this component is used to add new room
    const [BodyState, setBodyState] = useState("MINI-LOADING")
    const RecordController = useContext(RecordsManagementContext);
    const PageView = useContext(ViewMangementContext);
    const [RoomCategories, SetRoomCategories] = useState({});
    const [RoomId, SetRoomId] = useState('');
    let CustomerInvReq = RecordController.ML_Start.CustomerInventoryRequest;
    useEffect(() => {
        if (RecordController.Click) {
            Animation('new-room', RecordController.Click); // add animation class
        }
        RecordController.setIsActive(false);
        axios({
            method: 'post',
            url: FetchRoomCategoriesUrl,
            params: {estimate_key: Elink}
        }).then(async (response) =>{
            let current_location = window.location.href;
            let new_location = current_location.replace("client_estimate_mobile_link", "client_estimate");
            let Message = response.data.Message
            if(Message && Message.Status === "failed"){
                window.location = new_location
            }
            else{
                await SetRoomCategories(response.data);
                await setBodyState("Get Details");
            }
        });
    }, [])

    const ActiveNextButton = (element) =>{ // this component is used to make room button active
        let room_category = document.getElementsByClassName("category-list");
        let event = element;
        if (!element.className){
            event = event.parentElement
        }
        for( let e = 0; e < room_category.length; e++){
            if(room_category[e].id ===  event.id){
                RecordController.setIsActive(true);
                SetRoomId(event.id);
            }
        }

    }
    const GoToMyHome = () =>{ // back to home page
        RecordController.SetClick('back');
        AnimationPrevious ( "back-go",  "new-room",  "SHOW_MOBILE_LINK_MY_ROOMS", PageView);
    }
    const CreateNewRoom = () =>{ // create new room from room category
        if (RecordController.isActive && RoomId != 'custom') {
            setBodyState("MINI-LOADING");
            axios({
                method: 'post',
                url: CreateNewRoomUrl,
                params: {estimate_key: Elink, room_id: RoomId}
            }).then(async (response) => {
                let Message = response.data.Message
                let current_location = window.location.href;
                let new_location = current_location.replace("client_estimate_mobile_link", "client_estimate");
                if(Message && Message.Text === "Expired Link"){
                    window.location = new_location
                }
                else{
                    if (Message && Message.Status && Message.Status === "failed") {
                        PageView.setAlertProperty({
                            Message: Message.Text,
                            Type: Message.Type,
                            Show: true,
                            AutoHide: true
                        })
                        window.location.reload();
                    }
                    await setBodyState('Get Details')
                    await RecordController.setRoom(response.data);
                    await RecordController.SetClick('next');
                    await AnimationPrevious("next-go", "new-room", "ADD_INVENTORIES", PageView);
                }
            })
        }
    }

    const openCustomRoom = () =>{ // opening new page for custom room
        RecordController.SetClick('upward');
        AnimationPrevious ( "upward-go",  "new-room",  "CUSTOM_ROOM", PageView);
    }

    const addNewRoom = () => {
        return (
            <>
            <div className="container">
                <div className="row new-room-row">
                    <div className="col-md-2 col-lg-3 col-xl-3">
                        <div className="">
                            <button className=" btn-st-back" type="submit" onClick={()=>GoToMyHome()}
                                    style={{borderRadius: "8px", backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)}}>
                                Back</button>
                        </div>
                    </div>
                    <div className="col-12 col-md-8 col-lg-7 col-xl-6 ">
                        <div className="header-tx text-center">
                            <div className="cross" onClick={()=>GoToMyHome()}>
                                <i className="fa fa-times" aria-hidden="true" style={{color: GetTextColor(CustomerInvReq.BackgroundColor), fontSize: "25px"}}></i>
                            </div>
                            <h3 style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}>New Room</h3>
                        </div>
                    </div>
                    <div className="col-md-2 col-lg-3 col-xl-3">
                    </div>
                </div>
                <div className="lower-section text-center">
                    <div className="row d-flex align-items-center">
                        <div className={"col-md-2 col-lg-3 col-xl-3"}></div>
                        <div className="col-sm-12 col-md-8 col-lg-6 col-xl-6">
                            <div className="headline" style={{width: "0px !important"}}>
                                <h3 style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}>Category</h3>
                            </div>
                            {/* add loader, sometimes it take time to load all inventories */}
                            {BodyState === "MINI-LOADING" ? <MobileLinkLoader Height={"50vh"}/> :
                                <div className="category-btn mb-5" style={{paddingLeft: "0%"}}>
                                    {
                                        Object.entries(RoomCategories).map(([id, RoomType]) => {
                                            return (
                                                <a className="btn-category category-list" style={{marginRight: "3%", width: "0px !important", cursor: "pointer",
                                                    border: "1px solid", borderColor: RoomId===id ? GetTextColor(CustomerInvReq.ButtonColor) : CustomerInvReq.ButtonColor,
                                                    backgroundColor: RoomId===id ? CustomerInvReq.ButtonColor : '' }}
                                                   id={id} onClick={(e) => ActiveNextButton(e.target)}>
                                                <p style={{color: RoomId===id ? GetTextColor(CustomerInvReq.ButtonColor): CustomerInvReq.ButtonColor}}>{RoomType.Name}</p></a>
                                            )
                                        })
                                    }
                                    {
                                        CustomerInvReq.AllowCustomRoom ?
                                            <a className="btn-category category-custom" id={'custom'} onClick={(e) => openCustomRoom(e.target)}
                                               style={{marginRight: "3%", width: "0px !important", cursor: "pointer", border: "2px dashed", borderColor: CustomerInvReq.ButtonColor}}>
                                                <p style={{color: CustomerInvReq.ButtonColor}}>Custom</p>
                                            </a>
                                            : ''
                                    }
                                </div>
                            }
                        </div>
                        <div className={"col-md-2 col-lg-3 col-xl-3"}></div>
                    </div>
                </div>
            </div>
                <div style={{textAlign: "center"}}>
                    <button className={RecordController.isActive ?  "add-room-next-btn" : "add-room-next-btn-white"} type="submit" onClick={()=>CreateNewRoom()}
                            style={RecordController.isActive ? {backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)}:{}}>
                        <b>ADD ITEM</b> <i className="fas fa-arrow-right" aria-hidden="true"></i>
                    </button>
                </div>
            </>
        )
    }
    return (
        <>
            <section className="item-section-2 desktop-vw" style={{background: CustomerInvReq.BackgroundColor}}> {/* desktop view*/}
                <div className={"new-room"} style={{width: "100vw", position: "relative"}}>
                    {addNewRoom()}
                </div>
            </section>
            <section className="mobile-vw"> {/* mobile view*/}
                <div className="container-mv">
                    <svg viewBox="0 0 500 500"
                         preserveAspectRatio="xMinYMin meet"
                         style={{zIndex: -1}} id="svg-mv">
                        <path d="M0, 170 C360, 30, 630,
                510 595,-400 L900, 00 L0, 0 Z"
                              style={{stroke: "none",fill: CustomerInvReq.BackgroundColor}}>
                        </path>
                    </svg>

                </div>
                <div className={"new-room"} style={{width: "100vw", position: "relative"}}>
                    {addNewRoom()}
                </div>
            </section>
        </>
    )
}
export default AddNewRoom;